interface ActionKey {
  [key: string]: {
    actionName: string;
    isRedCorner: boolean;
  };
}

const actionsKeys: ActionKey = {
  'shift+1': {
    actionName: 'pointDeduction',
    isRedCorner: true,
  },
  'shift+0': {
    actionName: 'pointDeduction',
    isRedCorner: false,
  },
  z: {
    actionName: 'fightStart',
    isRedCorner: true,
  },
  x: {
    actionName: 'fightEnd',
    isRedCorner: true,
  },
  d: {
    actionName: 'takedown',
    isRedCorner: true,
  },
  f: {
    actionName: 'takedownAttempt',
    isRedCorner: true,
  },
  'shift+e': {
    actionName: 'significantStrike',
    isRedCorner: true,
  },
  r: {
    actionName: 'totalStrike',
    isRedCorner: true,
  },

  u: {
    actionName: 'totalStrike',
    isRedCorner: false,
  },
  'shift+i': {
    actionName: 'significantStrike',
    isRedCorner: false,
  },
  j: {
    actionName: 'takedownAttempt',
    isRedCorner: false,
  },
  k: {
    actionName: 'takedown',
    isRedCorner: false,
  },

  s: {
    actionName: 'takedownDefended',
    isRedCorner: true,
  },
  a: {
    actionName: 'submissionAttempt',
    isRedCorner: true,
  },
  c: {
    actionName: 'transition',
    isRedCorner: true,
  },
  g: {
    actionName: 'knockdown',
    isRedCorner: true,
  },

  h: {
    actionName: 'knockdown',
    isRedCorner: false,
  },
  m: {
    actionName: 'transition',
    isRedCorner: false,
  },
  n: {
    actionName: 'submissionAttempt',
    isRedCorner: false,
  },
  l: {
    actionName: 'takedownDefended',
    isRedCorner: false,
  },

  e: {
    actionName: 'significantStrikeHead',
    isRedCorner: true,
  },
  w: {
    actionName: 'significantStrikeBody',
    isRedCorner: true,
  },
  q: {
    actionName: 'significantStrikeLegs',
    isRedCorner: true,
  },

  i: {
    actionName: 'significantStrikeHead',
    isRedCorner: false,
  },
  o: {
    actionName: 'significantStrikeBody',
    isRedCorner: false,
  },
  p: {
    actionName: 'significantStrikeLegs',
    isRedCorner: false,
  },

  5: {
    actionName: 'controlStarted',
    isRedCorner: true,
  },
  'shift+5': {
    actionName: 'controlEnded',
    isRedCorner: true,
  },
  4: {
    actionName: 'controlStarted',
    isRedCorner: true,
  },
  'shift+4': {
    actionName: 'controlEnded',
    isRedCorner: true,
  },
  3: {
    actionName: 'controlStarted',
    isRedCorner: true,
  },
  'shift+3': {
    actionName: 'controlEnded',
    isRedCorner: true,
  },

  7: {
    actionName: 'controlStarted',
    isRedCorner: false,
  },
  'shift+7': {
    actionName: 'controlEnded',
    isRedCorner: false,
  },
  8: {
    actionName: 'controlStarted',
    isRedCorner: false,
  },
  'shift+8': {
    actionName: 'controlEnded',
    isRedCorner: false,
  },
  9: {
    actionName: 'controlStarted',
    isRedCorner: false,
  },
  'shift+9': {
    actionName: 'controlEnded',
    isRedCorner: false,
  },

  6: {
    actionName: 'reset',
    isRedCorner: true,
  },
  space: {
    actionName: 'timeout',
    isRedCorner: true,
  },
};

const wrestKeys: ActionKey = {
  z: {
    actionName: 'fightStart',
    isRedCorner: true,
  },
  x: {
    actionName: 'fightEnd',
    isRedCorner: true,
  },
  d: {
    actionName: 'takedown',
    isRedCorner: true,
  },
  f: {
    actionName: 'takedownAttempt',
    isRedCorner: true,
  },
  'shift+e': {
    actionName: 'escape',
    isRedCorner: true,
  },
  r: {
    actionName: 'nearFall',
    isRedCorner: true,
  },
  u: {
    actionName: 'nearFall',
    isRedCorner: false,
  },
  'shift+i': {
    actionName: 'escape',
    isRedCorner: false,
  },

  j: {
    actionName: 'takedownAttempt',
    isRedCorner: false,
  },
  k: {
    actionName: 'takedown',
    isRedCorner: false,
  },

  s: {
    actionName: 'exposure',
    isRedCorner: true,
  },
  a: {
    actionName: 'pinning',
    isRedCorner: true,
  },
  c: {
    actionName: 'technicalViolation',
    isRedCorner: true,
  },
  g: {
    actionName: 'reversal',
    isRedCorner: true,
  },
  h: {
    actionName: 'reversal',
    isRedCorner: false,
  },
  m: {
    actionName: 'technicalViolation',
    isRedCorner: false,
  },
  n: {
    actionName: 'pinning',
    isRedCorner: false,
  },
  l: {
    actionName: 'exposure',
    isRedCorner: false,
  },
  e: {
    actionName: 'turnover',
    isRedCorner: true,
  },
  w: {
    actionName: 'counterattack',
    isRedCorner: true,
  },
  q: {
    actionName: 'stalling',
    isRedCorner: true,
  },
  i: {
    actionName: 'stalling',
    isRedCorner: false,
  },
  o: {
    actionName: 'counterattack',
    isRedCorner: false,
  },
  p: {
    actionName: 'turnover',
    isRedCorner: false,
  },
  'shift+r': {
    actionName: 'fall',
    isRedCorner: true,
  },
  'shift+u': {
    actionName: 'fall',
    isRedCorner: false,
  },
  'shift+w': {
    actionName: 'role',
    isRedCorner: true,
  },
  'shift+o': {
    actionName: 'role',
    isRedCorner: false,
  },
  'shift+a': {
    actionName: 'outOfBound',
    isRedCorner: true,
  },
  'shift+n': {
    actionName: 'outOfBound',
    isRedCorner: false,
  },
  'shift+c': {
    actionName: 'passivity',
    isRedCorner: true,
  },
  'shift+g': {
    actionName: 'caution',
    isRedCorner: true,
  },
  'shift+h': {
    actionName: 'caution',
    isRedCorner: false,
  },
  'shift+m': {
    actionName: 'passivity',
    isRedCorner: false,
  },
  'shift+d': {
    actionName: 'backtake',
    isRedCorner: true,
  },
  'shift+j': {
    actionName: 'backtake',
    isRedCorner: false,
  },
  5: {
    actionName: 'controlStarted',
    isRedCorner: true,
  },
  'shift+5': {
    actionName: 'controlEnded',
    isRedCorner: true,
  },
  4: {
    actionName: 'controlStarted',
    isRedCorner: true,
  },
  'shift+4': {
    actionName: 'controlEnded',
    isRedCorner: true,
  },
  3: {
    actionName: 'controlStarted',
    isRedCorner: true,
  },
  'shift+3': {
    actionName: 'controlEnded',
    isRedCorner: true,
  },
  7: {
    actionName: 'controlStarted',
    isRedCorner: false,
  },
  'shift+7': {
    actionName: 'controlEnded',
    isRedCorner: false,
  },
  8: {
    actionName: 'controlStarted',
    isRedCorner: false,
  },
  'shift+8': {
    actionName: 'controlEnded',
    isRedCorner: false,
  },
  9: {
    actionName: 'controlStarted',
    isRedCorner: false,
  },
  'shift+9': {
    actionName: 'controlEnded',
    isRedCorner: false,
  },
  6: {
    actionName: 'reset',
    isRedCorner: true,
  },
  space: {
    actionName: 'timeout',
    isRedCorner: true,
  },
};

const grappling: ActionKey = {
  z: {
    actionName: 'fightStart',
    isRedCorner: true,
  },
  x: {
    actionName: 'fightEnd',
    isRedCorner: true,
  },
  d: {
    actionName: 'takedown',
    isRedCorner: true,
  },
  f: {
    actionName: 'takedownAttempt',
    isRedCorner: true,
  },
  j: {
    actionName: 'takedownAttempt',
    isRedCorner: false,
  },
  k: {
    actionName: 'takedown',
    isRedCorner: false,
  },
  s: {
    actionName: 'takedownDefended',
    isRedCorner: true,
  },
  a: {
    actionName: 'submissionAttempt',
    isRedCorner: true,
  },
  c: {
    actionName: 'transition',
    isRedCorner: true,
  },
  m: {
    actionName: 'transition',
    isRedCorner: false,
  },
  n: {
    actionName: 'submissionAttempt',
    isRedCorner: false,
  },
  l: {
    actionName: 'takedownDefended',
    isRedCorner: false,
  },
  q: {
    actionName: 'passivity',
    isRedCorner: true,
  },
  p: {
    actionName: 'passivity',
    isRedCorner: false,
  },
  w: {
    actionName: 'advantage',
    isRedCorner: true,
  },
  o: {
    actionName: 'advantage',
    isRedCorner: false,
  },
  5: {
    actionName: 'controlStarted',
    isRedCorner: true,
  },
  'shift+5': {
    actionName: 'controlEnded',
    isRedCorner: true,
  },
  3: {
    actionName: 'controlStarted',
    isRedCorner: true,
  },
  'shift+3': {
    actionName: 'controlEnded',
    isRedCorner: true,
  },

  7: {
    actionName: 'controlStarted',
    isRedCorner: false,
  },
  'shift+7': {
    actionName: 'controlEnded',
    isRedCorner: false,
  },
  9: {
    actionName: 'controlStarted',
    isRedCorner: false,
  },
  'shift+9': {
    actionName: 'controlEnded',
    isRedCorner: false,
  },

  6: {
    actionName: 'reset',
    isRedCorner: true,
  },
  space: {
    actionName: 'timeout',
    isRedCorner: true,
  },
};
export const keys = actionsKeys;
export const wrestlingKeys = wrestKeys;
export const grapplingKeys = grappling;
